import { createFileRoute } from "@tanstack/react-router";

import { BillingPage } from "@/components/Pages/Billing";

export const Route = createFileRoute("/_guard/billing/")({
  component: BillingPage,
});
